import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import isPropValid from '@emotion/is-prop-valid';

export default {
  AsLink: styled(Link, {
    shouldForwardProp: isPropValid
  })``
};
